// ink-component
import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

import getGlobalProps from '../../../../helpers/constants/global-props';

export interface PageContentProps extends HTMLAttributes<HTMLDivElement> {}

// Copied over from an older layout file
const columnWidth = Number((100 / 12).toFixed(5));

const PageContentElement = styled.div<HTMLAttributes<HTMLDivElement>>`
  flex-basis: ${columnWidth * 9}%;
  flex-grow: 1;
  padding: 16px;
`;

const globalProps = getGlobalProps({});

/**
 * @purpose Displays main content of the page
 * @group Page
 */
function PageContent(props: PageContentProps) {
  const { className, style, ...otherProps } = props;

  return <PageContentElement {...otherProps} {...globalProps} />;
}

PageContent.displayName = 'Page.Content';

export default PageContent;
